export default "__VITE_ASSET__f625cdd9__"